import RenderHTML from './RenderHTML.jsx';

export default RenderHTML;
